/**
 * Created by mykurisu on 2017/8/10.
 */
import React from 'react'
import {connect} from 'react-redux'
import '../../styles/search/SearchLiveroom.css'

class SearchLiveroomItem extends React.Component {

    handleEnterLiveroom (){
        const {liveroom} = this.props;
        if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())){
            window.location.href = `lizhiweike://liveroom?liveroom_id=${liveroom.id}`
        }else {
            window.location.href = `/liveroom/${liveroom.id}`
        }
    }

    render() {
        const {liveroom} = this.props;
        return (
            <div className="search-page-liveroom-item" onClick={this.handleEnterLiveroom.bind(this)}>
                <div className="search-page-liveroom-item-icon">
                    <div className="liveroom-slidetop-content-main-type">
                        {
                            liveroom.verify_type === 2 &&
                            <i className="iconfont verify-type-icon icon-yfv">
                            </i>
                        }
                        {
                            liveroom.verify_type === 1 &&
                            <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv">
                            </i>
                        }
                    </div>
                    <div className="search-page-liveroom-item-icon_img">
                        <img src={liveroom.small_avatar_url} alt=""/>
                    </div>
                </div>
                <div className="search-page-liveroom-item-name">
                    {liveroom.name}
                </div>
                <div className="search-page-liveroom-item-text">
                    {liveroom.fans_count >= 10000 ? (liveroom.fans_count/10000).toFixed(2) + "万" : liveroom.fans_count}<span>人关注</span>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    search: state.search,
    account: state.account
}))(SearchLiveroomItem);


// WEBPACK FOOTER //
// ./src/components/search/SearchLiveroomItem.js